import axios from "axios";
import React, { createContext, useState } from "react";
import { useHistory } from "react-router";
import { message } from "antd";
import Cookies from "js-cookie";

export const UserContext = createContext()

export const UserProvider = props => {

    let history = useHistory () 
    const [dataMove, setDataMove] = useState([])


    const [fetchStatus, setFetchStatus] = useState(true)
    const [input, setInput] = useState({
        title:"",
        description: "",
        year: 0,
        duration:0,
        genre:"",
        rating:0,
        review:"",
        image_url:""
    })
    const [currentId, setCurrentId] = useState(null)

    const getMovies = async () => {
        try{
        let res = await axios.get('https://backendexample.sanbersy.com/api/data-movie')
       let result = res.data
       setDataMove([...result])
    }catch (error) {
        console.log(error)
    }
    }
    const info = () => {
        message.info('Data Terhapus');
      }
   
    const handleDelete = async (event) => {
        let dataId = parseInt(event.currentTarget.value)
       await  axios.delete(`https://backendexample.sanbercloud.com/api/data-movie/${dataId}` , {headers: {"Authorization" : "Bearer "+ Cookies.get('token')}})
            setFetchStatus(true)
            info()
    }
    
    const handleEdit = async (event) => { 
        let dataId = parseInt(event.currentTarget.value)
        history.push(`/create-data-movies/edit/${dataId}`)
        
        
    }

    const getDataById = async (Id) => {
        let result = await axios.get(`https://backendexample.sanbercloud.com/api/data-movie/${Id}`)
        console.log(Id)
        console.log(result)
            setInput({title : result.data.title, description : result.data.description, year: result.data.year, duration: result.data.duration, genre:result.data.genre, rating:result.data.rating, review: result.data.review, image_url: result.data.image_url})
            setCurrentId (result.data.id)
    
        }
    

const handleChange = (event) => {
    let typeOfName = event.target.name
    let value = event.target.value

    setInput({...input, [typeOfName] : value})
}
const infoss = () => {
    message.info('Data Telah Ditambahkan!');
  }

const postData = async ({title, description, year, duration, genre, rating, review, image_url}) => {
    try {let result = await axios.post('https://backendexample.sanbercloud.com/api/data-movie', {title: input.title, description: input.description, year: input.year, duration: input.duration, genre: input.genre, rating : input.rating, review: input.review, image_url: input.image_url}, {headers: {"Authorization" : "Bearer "+ Cookies.get('token')}} )
    setFetchStatus(true)
    console.log(input)
    history.push("/data-movies")
    infoss()
}catch (err) {
    console.log(err) 
}
}

const infos = () => {
    message.info('Data Telah Diubah!');
  }

const replaceData = async ({title, description, year, duration, genre, rating, review, image_url}) => {
    try {let result = await axios.put(`https://backendexample.sanbercloud.com/api/data-movie/${currentId}`, {title: input.title, description: input.description, year: input.year, duration: input.duration, genre: input.genre, rating : input.rating, review: input.review, image_url: input.image_url}, {headers: {"Authorization" : "Bearer "+ Cookies.get('token')}})
    setFetchStatus(true)
    history.push("/data-movies")
    infos()
}catch (err) {
    console.log(err) }
}

const handleSubmit = (event) => {
    event.preventDefault()
    
    if (currentId === null) {
    
    postData(input)} 

    else {replaceData(input)}

    console.log(input)

    setInput ({
        title:"",
        description: "",
        year: 0,
        duration:0,
        genre:"",
        rating:0,
        review:"",
        image_url:""
})

setCurrentId(null)
}

    let functions = {getDataById, getMovies, handleDelete, handleEdit, handleChange, handleSubmit}
    
    return (
        <UserContext.Provider value={{dataMove, setDataMove, input, setInput, currentId, setCurrentId, fetchStatus, setFetchStatus, functions}}>
            {props.children}
        </UserContext.Provider>
    )
}